import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import DateField from 'react-mobx-admin/components/common/field/date'
import DateInput from '../input/date'
import Filters from '../global_filters'
import ListView from 'bstrap-react-mobx-admin/view/list'
import SelectInput from '../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import { DropdownButton, MenuItem } from 'react-bootstrap'

const FPVCategoriesListView = ({ store }) => {
  if (!store.hasRight(defaultConst.ENTNAMES.FP_CATEGORIES)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  const fields = [
    (attr, row) => {
      const DetailLink = ({ text }) => (
        <a href='javascript:void(0)' onClick={() => store.detailClicked(row)}>{text}</a>
      )
      return <TextField attr={attr} val={row[attr]} Component={DetailLink} />
    },
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => {
      const FilmDetail = (row) => {
        return store.hasRight(defaultConst.ENTNAMES.FILMS) ? (
          <a className='item-link-width' title={store.__('Click to open Film')} href='javascript:void(0)' onClick={() => {
            store.goTo('entity_detail', { entityname: 'films', id: row.video_id })
          }}>
            <span className='glyphicon glyphicon-share-alt' />&nbsp;{row.video_title}
          </a>
        ) : row.video_title
      }
      return <TextField attr={attr} val={row[attr]} Component={() => FilmDetail(row)} />
    },
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.valid_to} />),
    (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.valid_from} />)
  ]

  const batchActions = () => {
    const dateRestriction = store.timeRestriction[store.router.params.entityname]
    const disableUpdate = store.cv.disableUpdate(store.cv.items, store.cv.selection, dateRestriction)
    const disableEditDelete = store.cv.disableEditDelete(store.cv.items, store.cv.selection, dateRestriction)

    return (
      <DropdownButton className={defaultConst.ACTION_BUTTON_CLASS1} title={store.__(defaultConst.TITLE_BATCH_ACTIONS)} pullRight id='listactions-dropdown'>
        <MenuItem key={linkConst.BATCH_ACTION_CATEGORIES_UPDATE} eventKey={linkConst.BATCH_ACTION_CATEGORIES_UPDATE}
          onClick={disableUpdate ? null : store.gotoBatch.bind(store, linkConst.BATCH_ACTION_CATEGORIES_UPDATE)} disabled={disableUpdate}>
          <span className={linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_CATEGORIES_UPDATE].icon} />&nbsp;
          {store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_CATEGORIES_UPDATE].title)} {disableUpdate && ' */'}
        </MenuItem>
        <MenuItem divider />
        <MenuItem key={'delete'} eventKey={'delete'} onClick={disableEditDelete ? null : store.batchDelete.bind(store)} disabled={disableEditDelete}>
          <span className='glyphicon glyphicon-remove' />&nbsp;
          {store.__(defaultConst.TITLE_DELETE)} {disableEditDelete && ' */'}
        </MenuItem>
        {disableUpdate || disableEditDelete ? store.cv.disableMenuInfo : null}
      </DropdownButton>
    )
  }

  const platformFilterName = 'fp_platform_enumtext'
  const platformFSelector = store.platformFSelector[platformFilterName] ||
    (store.cv.filters.has(platformFilterName) && store.cv.filters.get(platformFilterName))

  const filters = {
    id_like: {
      title: 'ID',
      component: (props) => (<TextInput {...props} />)
    },
    fp_platform_enumtext: {
      title: 'Platform',
      component: (props) => (<SelectInput
        {...props}
        optionsrecord={store.options}
        labelattr='text'
        valueattr='text'
        onChange={(k, v) => {
          store.cv.filters.set(k, v)
          store.platformFSelectorUpdate(k, v)
        }}
        optionsattr={'FlyPrivatePlatforms'} />)
    },
    enum_value_enumtext: {
      title: 'Category',
      component: (props) => (
        <SelectInput {...props}
          optionsrecord={store.options}
          labelattr='text'
          valueattr='text'
          valueFilterFc={platformFSelector && store.cv.filters.has(platformFilterName)
            ? store.getCatPlatformFilter(platformFSelector)
            : undefined}
          optionsattr={'FlyprivateCategories'} />)
    },
    order: {
      title: 'Order',
      component: (props) => (<TextInput {...props} />)
    },
    video_title_like: {
      title: 'Film',
      component: (props) => (<TextInput {...props} />)
    },
    regions: {
      title: 'rRgion',
      component: (props) => (<TextInput {...props} />)
    },
    valid_from__from: {
      title: 'Valid from',
      component: (props) => (
        <div>
          <DateInput hideControlLabel asFilter {...props} />
          <DateInput hideControlLabel asFilter {...props} attr={props.attr + '__to'} />
        </div>
      )
    },
    valid_to__from: {
      title: 'Valid to',
      component: (props) => (
        <div>
          <DateInput hideControlLabel asFilter {...props} />
          <DateInput hideControlLabel asFilter {...props} attr={props.attr + '__to'} />
        </div>
      )
    }
  }

  return (<ListView
    store={store.cv}
    helper={store.helpFor(linkConst.LINK_CATEGORIES)}
    fields={fields}
    filters={() => Filters(store, filters)}
    onAddClicked={store.addClicked.bind(store)}
    onAddClickedFL={store.lastSaved && store.lastSaved.FPVCategories && store.addClicked.bind(store, true, 'FPVCategories')}
    batchActions={batchActions}
    batchMenuControl={true}
  />)
}
FPVCategoriesListView.propTypes = {
  store: PropTypes.object.isRequired
}

export default observer(FPVCategoriesListView)
